import { PayloadAction } from '../../../store.model';
import { ActionType } from '../form.action';
import { FormState } from '../form.state';

import { Save, SaveResult } from './save.action';

export function saveReducer(
    state: FormState,
    action: PayloadAction<ActionType.EVAL_FORM__SAVE, Save>,
): FormState {
    return {
        ...state,
        pending: {
            ...state.pending,
            save: true,
            publish: action.payload.publish ?? state.pending.publish,
        },
    };
}

export function saveResultReducer(
    state: FormState,
    action: PayloadAction<ActionType.EVAL_FORM__SAVE_RESULT, SaveResult>,
): FormState {
    try {
        let nextDraft = state.draft;
        let nextForm = state.form;
        if (action.payload.draft != null) {
            nextDraft = action.payload.draft;
            nextForm = nextDraft.form;

            nextForm.eventDate =
                nextForm.eventDate == null
                    ? null
                    : new Date(nextForm.eventDate);
            nextForm.evaluationDate =
                nextForm.evaluationDate == null
                    ? null
                    : new Date(nextForm.evaluationDate);
        }

        return {
            ...state,
            pending: {
                ...state.pending,
                save: false,
                publish: false,
            },
            draft: nextDraft,
            form: nextForm,
        };
    } catch {
        return {
            ...state,
            pending: {
                ...state.pending,
                save: false,
                publish: false,
            },
        };
    }
}
